export const PERMISSIONS = {
  // Fase 1
  CONSENTS_READ: 'consents:read',
  CONSENTS_MANAGE: 'consents:manage',
  LAB_READ: 'lab:read',
  LAB_MANAGE: 'lab:manage',

  // Fase 2
  ACCOUNTING_READ: 'accounting:read',
  ACCOUNTING_MANAGE: 'accounting:manage',
  RESOURCES_READ: 'resources:read',
  RESOURCES_MANAGE: 'resources:manage',

  // Fase 3
  RECEPTION_MANAGE: 'reception:manage',
  MARKETING_READ: 'marketing:read',
  MARKETING_MANAGE: 'marketing:manage',

  // Fase 4
  REPUTATION_READ: 'reputation:read',
  REPUTATION_MANAGE: 'reputation:manage',
  CLINICAL_KPIS_READ: 'clinical_kpis:read',
  PROCUREMENT_READ: 'procurement:read',
  PROCUREMENT_MANAGE: 'procurement:manage',
} as const

export type Permission = (typeof PERMISSIONS)[keyof typeof PERMISSIONS]
